// import { isMobile } from 'react-device-detect';
// import { ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts"
// import DatePicker from "react-datepicker"
// import "react-datepicker/dist/react-datepicker.css"
// import { formatDate, formatMinutes } from '../../../utils/utils';
// import NoDataFound from '../../NoDataFound';
// import Form from 'react-bootstrap/Form';
// import { useMemo } from 'react';
// import ReactECharts from "echarts-for-react";

// const CustomTooltip = ({ active, payload, label }) => {
//   if (active && payload && payload.length) {
//     const d = payload[0].payload;
//     return (
//       <div className="bg-white border rounded p-3 shadow-sm">
//         <p className="fw-bold mb-2 text-dark">{label}</p>
//         {payload.map((entry, i) => {
//           return(
//             <p key={i} style={{ margin: 0 }} className="small">
//               <div>Active Time: <strong>{formatMinutes(d.time_spend)}</strong></div>
//               {/* <strong>{entry.name}:</strong> {entry.value} */}
//               {/* {entry.name.includes("Time") ? " mins" : ""} */}
//               {/* <br/> */}
//               <strong>Status:</strong> <span className={`${entry.payload?.status =="Present" ? 'text-success':'text-danger'}`}>{entry.payload?.status}</span>
//             </p>
//           )
//         })}
//       </div>
//     )
//   }
//   return null
// }

// function normalizeDate(dateStr) {
//     return dateStr.split(" ")[0];
// }

// const StudentAttendance=({
//     handleFilterChange,
//     startDate,
//     handleStartDateChange,
//     endDate,
//     handleEndDateChange,
//     formatDateLabel,
//     formatMinutes,
//     studentAttendaceData
// })=>{

//     function getWeeklyData(apiData, startDate, endDate) {
//         const start = new Date(startDate);
//         const end = new Date(endDate);
//         // end.setDate(start.getDate() + 6);

//         const weekData = apiData.filter((item) => {
//         const d = new Date(normalizeDate(item.attendance_date));
//         return d >= start && d <= end;
//         });

//         return weekData.map((item) => {
//         const normalizedDate = normalizeDate(item.attendance_date);
//         return {
//             ...item,
//             attendance_date: normalizedDate,
//             dayLabel: item.attendance_date,
//             time_spend: Number(((Number(item.time_spend) || 0) / 60).toFixed(1)), 
//             status: item.status.charAt(0).toUpperCase() + item.status.slice(1)
//         };
//         });
//     }

//     const weeklyData = useMemo(
//         () => getWeeklyData(studentAttendaceData, startDate, endDate),
//         [studentAttendaceData, startDate, endDate]
//     );

//     const maxValue = useMemo(()=>!weeklyData || weeklyData.length === 0 ? 0:Math.max(...weeklyData.map(d => d.time_spend)),[weeklyData])

//     const heatmapData = studentAttendaceData.map((d) => [
//         d.attendance_date.split(" ")[0], 
//         1,
//     ]);

//     const option = {
//         title: {
//         top: 20,
//         left: "center",
//         text: "📅 Student Attendance (2025)"
//         },
//         tooltip: {
//         position: "top",
//         formatter: (p) => {
//             return `Present on <b>${p.data[0]}</b>`;
//         },
//         },
//         visualMap: {
//         show: false, // hide legend since we only have 0 or 1
//         min: 0,
//         max: 1,
//         inRange: {
//             color: ["#f0f0f0", "#3b82f6"], // gray = absent, blue = present
//         },
//         },
//         calendar: {
//         top: 80,
//         left: 30,
//         right: 30,
//         cellSize: ["auto", 20],
//         range: "2025",
//         splitLine: {
//             show: true,
//             lineStyle: {
//             color: "#ddd",
//             width: 1,
//             },
//         },
//         dayLabel: {
//             firstDay: 1,
//             nameMap: "en",
//         },
//         monthLabel: {
//             nameMap: "en",
//             margin: 15,
//         },
//         yearLabel: { show: false },
//         },
//         series: [
//         {
//             type: "heatmap",
//             coordinateSystem: "calendar",
//             data: heatmapData,
//         },
//         ],
//     };

//     return(
//         <div className="">
//             <div className="card border rounded-4">
//             <div className="card-header">
//                 <div className="row align-items-center g-3">
//                 <div className="col-12 col-md-6">
//                     <h4 className="mb-0 fw-bold text-dark d-flex align-items-center">
//                     <i className="bi bi-bar-chart-fill text-primary me-2"></i>
//                     Weekly Attendance
//                     </h4>
//                 </div>
//                 {/* <div className="col-12 col-md-6">
//                     <div className="row g-3">
//                     <div className="col-12 col-sm-4">
//                         <label className="form-label small text-muted mb-1">Custom Range</label>
//                         <Form.Select
//                             onChange={(e) => handleFilterChange(e.target.value)}
//                             className="datepickerheight"
//                         >
//                         <option value="currentWeek">Current Week</option>
//                         <option value="lastWeek">Last Week</option>
//                         <option value="currentMonth">Current Month</option>
//                         </Form.Select>
//                     </div>

//                     <div className="col-12 col-sm-4">
//                         <label className="form-label small text-muted mb-1">Start Date</label>
//                         <div className='dt'>
//                         <DatePicker
//                             selected={startDate}
//                             onChange={handleStartDateChange}
//                             dateFormat="dd/MM/yyyy"
//                             className="form-control datepickerheight "
//                             placeholderText="Select start date"
//                         />
//                         </div>
//                     </div>
//                     <div className="col-12 col-sm-4">
//                         <label className="form-label small text-muted mb-1">End Date</label>
//                         <div className='dt'>
//                         <DatePicker
//                             selected={endDate}
//                             onChange={handleEndDateChange}
//                             dateFormat="dd/MM/yyyy"
//                             className="form-control datepickerheight"
//                             placeholderText="Select end date"
//                             minDate={startDate}
//                         />
//                         </div>
//                     </div>
//                     </div>
//                 </div> */}
//                 </div>
//             </div>

//             <div className="card-body">
//                 <ReactECharts option={option} style={{ height: 300 }} />
//                 {/* <div className="bg-light rounded-4 p-4">
//                 {!weeklyData || weeklyData.length === 0 ? <NoDataFound message='📊 No attendance data is available for this student.'/> :
//                 <>
//                     <div className="d-flex justify-content-between align-items-center mb-3">
//                     <h6 className="mb-0 text-dark fw-semibold">
//                         Active Time Tracking ({formatDate(startDate)} → {formatDate(endDate)})
//                     </h6>
//                     </div>

//                     <div className="chart-container" style={{ width: "100%", overflowX: "auto" }}>
//                     <div style={{
//                         width: isMobile ? Math.max(weeklyData.length * 100, 600) : "100%",
//                         height: 500,
//                         minWidth: 500,
//                     }}
//                     >
//                         <ResponsiveContainer width="100%" height="100%">
//                         <ComposedChart data={weeklyData} margin={{ top: 20, right: 30, left: 20, bottom: 60 }}>
//                             <CartesianGrid strokeDasharray="3 3" stroke="#e9ecef" />
//                             <XAxis
//                                 dataKey="dayLabel"
//                                 stroke="#6c757d"
//                                 fontSize={12}
//                                 tickLine={false}
//                                 angle={-55}
//                                 textAnchor="end"
//                                 height={80}
//                                 tickFormatter={(date) => formatDateLabel(date)}
//                             />
//                             <YAxis
//                                 yAxisId="left"
//                                 stroke="#6c757d"
//                                 fontSize={12}
//                                 tickLine={false}
//                                 domain={[0, maxValue]}
//                                 tickFormatter={formatMinutes}
//                             />
//                             <YAxis
//                                 yAxisId="right"
//                                 orientation="right"
//                                 stroke="#6c757d"
//                                 fontSize={12}
//                                 tickLine={false}
//                                 domain={[0, 1]}
//                                 tickFormatter={(v) => (v === 1 ? "Present" : "")}
//                             />
//                             <Tooltip content={<CustomTooltip />} />
//                             <Bar
//                                 yAxisId="left"
//                                 dataKey="time_spend"
//                                 fill="#0d6efd"
//                                 name="Active Time (mins)"
//                                 radius={[4, 4, 0, 0]}
//                                 barSize={50}
//                             />
//                         </ComposedChart>
//                         </ResponsiveContainer>
//                     </div>
//                     </div>
//                 </>}
//                 </div> */}
//             </div>
//             </div>
//         </div>
//     )
// }

// export default StudentAttendance




import { useState, useMemo } from "react";
import { Clock } from 'lucide-react';
import { Col, Form, Row } from 'react-bootstrap';
import { isMobile } from "react-device-detect";

const StudentAttendance = ({ attendanceData = [] }) => {
  const [hoveredDay, setHoveredDay] = useState(null);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const getTimeLevel = (minutes) => {
    if (!minutes || minutes === 0) return 0;
    if (minutes < 60) return 1;
    if (minutes < 120) return 2;
    if (minutes < 180) return 3;
    return 4;
  };

  const processAttendanceData = () => {
    const data = {};
    attendanceData.forEach(item => {
      const dateStr = item.attendance_date?.split(' ')[0];
      if (dateStr) {
        data[dateStr] = {
          present: item.status?.toLowerCase() === 'present',
          timeSpent: Math.round(Number(item.time_spend) || 0),
          status: item.status
        };
      }
    });
    return data;
  };

  const availableYears = useMemo(() => {
    const years = new Set();
    attendanceData.forEach(item => {
      const year = new Date(item.attendance_date).getFullYear();
      years.add(year);
    });

    const min = Math.min(...Array.from(years), new Date().getFullYear());
    const max = new Date().getFullYear() + 3;
    return Array.from({ length: max - min + 1 }, (_, i) => min + i);
  }, [attendanceData]);

  const generateCalendarData = () => {
    const processedData = processAttendanceData();
    const months = [];
    
    for (let month = 0; month < 12; month++) {
      const monthStart = new Date(selectedYear, month, 1);
      const monthEnd = new Date(selectedYear, month + 1, 0);
      
      const startDate = new Date(monthStart);
      const dayOfWeek = startDate.getDay();
      if (dayOfWeek !== 0) {
        startDate.setDate(startDate.getDate() - dayOfWeek);
      }
      
      // Find the Saturday after or on the last day of the month
      const endDate = new Date(monthEnd);
      const endDayOfWeek = endDate.getDay();
      if (endDayOfWeek !== 6) {
        endDate.setDate(endDate.getDate() + (6 - endDayOfWeek));
      }
      
      const weeks = [];
      let currentWeek = [];
      const currentDate = new Date(startDate);
      
      while (currentDate <= endDate) {
        const dateStr = currentDate.toISOString().split('T')[0];
        const dayData = processedData[dateStr];
        const isInCurrentMonth = currentDate.getMonth() === month;
        
        currentWeek.push({
          date: dateStr,
          timeSpent: dayData?.timeSpent || 0,
          level: getTimeLevel(dayData?.timeSpent),
          present: dayData?.present || false,
          status: dayData?.status || 'Absent',
          day: currentDate.getDay(),
          isInCurrentMonth: isInCurrentMonth
        });
        
        if (currentDate.getDay() === 6) {
          weeks.push(currentWeek);
          currentWeek = [];
        }
        
        currentDate.setDate(currentDate.getDate() + 1);
      }
      
      if (currentWeek.length > 0) {
        weeks.push(currentWeek);
      }
      
      months.push({ month, weeks });
    }
    
    return months;
  };

  const monthsData = generateCalendarData();
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });
  };

  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    let str = "";
    if (h > 0) str += `${h}h `;
    if (m > 0) str += `${m}m `;
    if (s > 0 && h === 0) str += `${s}s`; // only show seconds if < 1h
    return str.trim() || "0s";
  };
  
  return (
    <div style={styles.container}>
      <div className="mb-3 d-flex justify-content-between align-items-center" style={{ flexDirection:isMobile? "column":"row"}}>
        <Row className="align-items-center mb-2">
          <Col>
            <h5 className="fw-bold text-dark d-flex align-items-center">
              <i className="bi bi-grid-3x3-gap-fill text-primary me-2"></i>
              Activity Tracker
            </h5>
          </Col>
        </Row>

        <Row className="align-items-center">
          <Col xs="auto">
            <Form.Label className="mb-0 fw-semibold">Select Year:</Form.Label>
          </Col>
          <Col xs="auto">
            <Form.Select aria-label="Year select">
              {availableYears.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>
      </div>

      <div style={styles.calendarWrapper}>
        <div style={styles.dayLabels}>
          {weekDays.map((day, i) => (
            <div key={day} style={{...styles.dayLabel, top: `${i * 23}px`}}>
              {day}
            </div>
          ))}
        </div>

        <div style={styles.calendarContainer}>
          {monthsData.map(({ month, weeks }) => (
            <div key={month} style={styles.monthContainer}>
              <div style={styles.monthLabel}>
                {monthNames[month]}
              </div>
              
              <div style={styles.monthGrid}>
                {weeks.map((week, weekIndex) => (
                  <div key={weekIndex} style={styles.week}>
                    {week.map((day, dayIndex) => (
                      <div
                        key={`${month}-${weekIndex}-${dayIndex}`}
                        style={{
                          ...styles.day,
                          ...(day.isInCurrentMonth ? styles[`level${day.level}`] : styles.outOfRange),
                          fontSize: 10,
                          textAlign: 'center',
                        }}
                        onMouseEnter={(e) => {
                          setHoveredDay({...day, x: e.clientX, y: e.clientY});
                        }}
                        onMouseLeave={() => setHoveredDay(null)}
                      >
                        {new Date(day.date).getDate()}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {hoveredDay && hoveredDay.present && (
          <div style={{
            ...styles.tooltip,
            left: hoveredDay.x + 50 + 'px',
            top: (hoveredDay.y+20) + 'px'
          }}>
            <div style={styles.tooltipDate}>{formatDate(hoveredDay.date)}</div>
            <div style={styles.tooltipRow}>
              <Clock size={14} />
              <span>Time: {formatTime(hoveredDay.timeSpent)}</span>
            </div>
            <div style={styles.tooltipRow}>
              <span className={hoveredDay.status === 'Present' ? 'text-success' : 'text-danger'}>
                Status: {hoveredDay.status}
              </span>
            </div>
          </div>
        )}
        {hoveredDay && !hoveredDay.present && hoveredDay.isInCurrentMonth && (
          <div style={{
            ...styles.tooltip,
            left: hoveredDay.x+50 + 'px',
            top: (hoveredDay.y +20) + 'px'
          }}>
            <div style={styles.tooltipDate}>{formatDate(hoveredDay.date)}</div>
            <div style={styles.tooltipAbsent}>No activity</div>
          </div>
        )}
      </div>

      <div style={styles.legend}>
        <span style={styles.legendText}>Less</span>
        {[0, 1, 2, 3, 4].map(level => (
          <div
            key={level}
            style={{...styles.legendBox, ...styles[`level${level}`]}}
          />
        ))}
        <span style={styles.legendText}>More</span>
        <span style={styles.legendInfo}>
          (No activity, &lt;1h, 1-2h, 2-3h, 3h+)
        </span>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '20px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    border: '1px solid #e5e7eb'
  },
  header: {
    marginBottom: '20px'
  },
  subtitle: {
    fontSize: '14px',
    color: '#6b7280',
    margin: 0
  },
  calendarWrapper: {
    position: 'relative',
    display: 'inline-block',
    padding: '20px 0',
    overflowX: 'auto',
    maxWidth: '100%'
  },
  dayLabels: {
    position: 'absolute',
    left: '-25px',
    top: '45px',
  },
  dayLabel: {
    position: 'absolute',
    fontSize: '10px',
    color: '#6b7280',
    textAlign: 'right',
    width: '48px'
  },
  calendarContainer: {
    display: 'flex',
    gap: '15px',
    marginLeft: '35px',
    overflowX: 'auto',
    paddingBottom: '10px'
  },
  monthContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  monthLabel: {
    fontSize: '11px',
    color: '#6b7280',
    marginBottom: '5px',
    fontWeight: '500',
    textAlign: 'center',
    minWidth: '40px'
  },
  monthGrid: {
    display: 'flex',
    gap: '1px'
  },
  week: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3px'
  },
  day: {
    width: '20px',
    height: '20px',
    borderRadius: '2px',
    cursor: 'pointer',
    transition: 'all 0.1s ease'
  },
  outOfRange: {
    backgroundColor: '#f3f4f6',
    border: '1px solid #e5e7eb',
    opacity: 0.3,
    cursor: 'default'
  },
  level0: {
    backgroundColor: '#ebedf0',
    border: '1px solid #e5e7eb',
    // color:"red"
  },
  level1: {
    backgroundColor: '#9be9a8',
    color:"white"
  },
  level2: {
    backgroundColor: '#40c463',
    color:"white"
  },
  level3: {
    backgroundColor: '#30a14e',
    color:"white"
  },
  level4: {
    backgroundColor: '#216e39',
    color:"white"
  },
  tooltip: {
    position: 'fixed',
    backgroundColor: '#1f2937',
    border: '1px solid #374151',
    borderRadius: '6px',
    padding: '12px',
    fontSize: '12px',
    pointerEvents: 'none',
    zIndex: 1000,
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
    transform: 'translateX(-50%)',
    minWidth: '180px',
    color: '#f3f4f6'
  },
  tooltipDate: {
    fontWeight: 'bold',
    marginBottom: '8px',
    paddingBottom: '8px',
    borderBottom: '1px solid #374151'
  },
  tooltipRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '6px',
    color: '#d1d5db'
  },
  tooltipAbsent: {
    color: '#9ca3af',
    fontStyle: 'italic',
    marginTop: '4px'
  },
  legend: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginTop: '15px',
    fontSize: '11px'
  },
  legendText: {
    color: '#6b7280',
    margin: '0 4px'
  },
  legendBox: {
    width: '12px',
    height: '12px',
    borderRadius: '2px'
  },
  legendInfo: {
    color: '#6b7280',
    marginLeft: '8px',
    fontSize: '10px'
  }
};

export default StudentAttendance;